import { render, staticRenderFns } from "./i4pro-card-news-ecm.vue?vue&type=template&id=2e845e1a&scoped=true"
import script from "./i4pro-card-news-ecm.vue?vue&type=script&lang=js"
export * from "./i4pro-card-news-ecm.vue?vue&type=script&lang=js"
import style0 from "./i4pro-card-news-ecm.vue?vue&type=style&index=0&id=2e845e1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e845e1a",
  null
  
)

export default component.exports